import { SaveRenamePayload } from "../types/watch-list-info.types";
import {
  AllWatchlistsResponse,
  SpecificWatchlistResponse,
  WatchlistWithMetadata,
} from "../types/watch-list-types.types";
import { API_PATHS } from "../constants/api-paths";
import { getSessionData } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest } from "../core/api.client";

export const getWatchList = async (
  id?: number | string,
  page?: number,
  limit?: number
): Promise<IResponse<SpecificWatchlistResponse | AllWatchlistsResponse>> => {
  try {
    const { mobileNo } = await getSessionData();
    if (!mobileNo) {
      throw new Error("Missing Mobile No");
    }
    const response = await encryptedRequest<SpecificWatchlistResponse | AllWatchlistsResponse>({
      method: "POST",
      url: API_PATHS.getWatchList,
      data: {
        mobileNo,
        wlId: `${id}`,
        page: page || 1,
        limit: limit || 20,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const renameWatchList = async (payLoad: SaveRenamePayload) => {
  try {
    const { mobileNo } = await getSessionData();
    if (!mobileNo) {
      throw new Error("Missing Mobile No");
    }
    const response = await encryptedRequest({
      method: "POST",
      url: API_PATHS.renameWatchList,
      data: {
        mobileNo,
        ...payLoad,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateWatchListStocks = async (
  wlData: string,
  id: string,
  wlName: string
): Promise<IResponse<WatchlistWithMetadata | null>> => {
  const { mobileNo } = await getSessionData();
  if (!mobileNo) {
    throw new Error("Missing Mobile No");
  }
  const response = await encryptedRequest<WatchlistWithMetadata | null>({
    method: "POST",
    url: API_PATHS.updateWatchList,
    data: {
      mobileNo,
      wlName,
      wlId: id,
      wlData,
    },
  });
  return response;
};
